module.exports = __webpack_public_path__ + "static/media/burger.beed5e5e.jpg";